import React, { useCallback, useEffect, useReducer } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import BaseTorneos from './BaseTorneos.js';
import MensajeCargando from '../UI/MensajeCargando.js';
import MensajeError from '../UI/MensajeError.js';
import { Torneo as Filtros } from '../constantes/Filtros.js';
import * as Funciones from '../funciones/FuncionesTorneos.js';
import * as Reducer from '../reducers/ReducerTorneos.js';
import styles from './CuerpoTorneos.module.css';
import useGetURL from '../../hooks/useGetURL.js';

const RouterTorneos = (props) => {
  const filtro = props.filtro;
  const parameters = useParams();
  const { isCargando, erroresGet, fetchData, resetErroresGet } = useGetURL();
  const { state } = useLocation();
  const datosBase = state ? state.datosElegidos : Reducer.ReducerVacio;
  const [datosElegidos, setDatosElegidos] = useReducer(Reducer.ReducerElegidos, datosBase);

  useEffect(() => {
    document.title = Funciones.TituloPaginaTorneo(filtro, datosElegidos, RouterTorneos.name);
  }, [filtro, datosElegidos]);

  let url = '';
  let filtroAplicar = filtro;
  // si no está cargado el torneo, lo cargo antes de cargar el equipo o la etapa
  if ((filtro === Filtros.EQUIPO || filtro === Filtros.ETAPA) && !datosElegidos.torneo) {
    url = Funciones.URLFiltro(Filtros.TORNEO, parameters, datosElegidos);
    filtroAplicar = Filtros.TORNEO;
  } else {
    url = Funciones.URLFiltro(filtroAplicar, parameters, datosElegidos);
    filtroAplicar = filtro;
  }

  useEffect(() => {
    resetErroresGet();
  }, [resetErroresGet]);

  const itemCargado = useCallback(
    (item) => {
      setDatosElegidos({ type: filtroAplicar, value: item });
    },
    [filtroAplicar]
  );

  useEffect(() => {
    if (url === '') {
      alert('No se informó el id');
    } else {
      fetchData(url, itemCargado);
    }
  }, [url, fetchData, itemCargado]);

  return (
    <React.Fragment>
      {!isCargando && datosElegidos && <BaseTorneos datosElegidos={datosElegidos} />}
      <MensajeCargando estilo={`${styles.cargando}`} isCargando={isCargando} />
      <MensajeError estilo={`${styles.error}`} errores={erroresGet} />
    </React.Fragment>
  );
};

export default RouterTorneos;
